import * as S from './styles'

interface IFileDetailProps {
  name: string
  size: string
  onClickDelete?: () => void
  onClickDownload?: () => void
}

const FileDetail = ({
  name,
  size,
  onClickDelete,
  onClickDownload,
}: IFileDetailProps) => {
  return (
    <S.Container>
      <S.Text>{name}</S.Text>
      <S.Text>{size}</S.Text>
      {!!onClickDelete && <S.StyledDeleteIcon onClick={onClickDelete} />}
      {!!onClickDownload && <S.StyledDownloadIcon onClick={onClickDownload} />}
    </S.Container>
  )
}

export { FileDetail }
export type { IFileDetailProps }
